<template>
  <b-card>
    <div class="formContent">
      <div class="title">
        <span>Cadastro de Aplicador</span>
        <span class="requiredFields">* Campos Obrigatórios</span>
      </div>

      <div class="rowContainer">
        <span><b-icon-person-lines-fill /> Informações Gerais</span>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              placeholder=" "
              class="input borderInput"
              v-model="dadosAplicador.nomeAplicador"
            />
            <label class="user-label"
              >Nome Aplicador <span class="validRed">*</span></label
            >
          </div>
          <div class="input-group">
            <input
              placeholder=" "
              class="input borderInput"
              v-model="dadosAplicador.cpfCnpj"
              v-mask="maskCpfCnpj"
            />
            <label class="user-label">CPF/CNPJ</label>
          </div>
          <div class="input-group">
            <input
              placeholder=" "
              class="input borderInput"
              v-model="dadosAplicador.numeroRegistro"
            />
            <label class="user-label">Nº Registro</label>
          </div>
        </div>
      </div>

      <div class="rowContainer">
        <span><b-icon-geo-alt-fill /> Localização</span>
        <div class="rowContent">
          <div class="input-group">
            <input
              placeholder=" "
              class="input borderInput"
              v-model="dadosAplicador.cep"
              v-mask="maskCep"
            />
            <label class="user-label">CEP</label>
            <button class="bcsCep" @click="fetchCep">
              <b-spinner v-if="spinGeneral" small label="Buscando CEP" />
              buscar
            </button>
          </div>
          <div class="input-group">
            <input
              placeholder=" "
              class="input borderInput"
              v-model="dadosAplicador.endereco"
            />
            <label class="user-label">Endereço</label>
          </div>
          <div class="input-group">
            <input placeholder=" " class="input borderInput" v-model="dadosAplicador.cidade" />
            <label class="user-label">Cidade</label>
          </div>
        </div>
        <div class="rowContent">
          <div class="input-group">
            <input placeholder=" " class="input borderInput" v-model="dadosAplicador.bairro" />
            <label class="user-label">Bairro</label>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect2">UF</label>
            <b-form-select
              class="borderInput shadow-none"
              :options="ufs"
              v-model="dadosAplicador.uf"
            />
          </div>
          <div class="input-group">
            <input placeholder=" " class="input borderInput" v-model="dadosAplicador.numero" />
            <label class="user-label">Número</label>
          </div>
        </div>
      </div>

      <div class="rowContainer">
        <span><b-icon-telephone-fill /> Contatos</span>
        <div class="rowContent">
          <div class="input-group">
            <input
              type="email"
              placeholder=" "
              class="input borderInput"
              v-model="dadosAplicador.email"
            />
            <label class="user-label">Email</label>
          </div>
          <div class="input-group">
            <input
              placeholder=" "
              class="input borderInput"
              v-model="dadosAplicador.telefone"
              v-mask="maskTelefone"
            />
            <label class="user-label">Telefone</label>
          </div>
          <div class="input-group">
            <input
              placeholder=" "
              class="input borderInput"
              v-model="dadosAplicador.celular"
              v-mask="maskCelular"
            />
            <label class="user-label">Celular</label>
          </div>
        </div>
      </div>

      <div class="rowContainer lastRow">
        <span><b-icon-info-circle-fill /> Outras Informações</span>
        <div class="rowContent otherInfo">
          <div class="input-group observations">
            <input
              placeholder=" "
              class="input borderInput"
              v-model="dadosAplicador.observacao"
            />
            <label class="user-label">Observações</label>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect2">Status</label>
            <b-form-select
              class="borderInput shadow-none"
              :options="status"
              v-model="dadosAplicador.status"
              :disabled="!dadosAplicador.id"
            />
          </div>
        </div>
        <div class="btnsContainer">
          <b-button class="btnsSaveNeutral" @click="clear">
            Novo <b-icon-arrow-clockwise class="ml-1" />
          </b-button>
          <b-button
            class="btnsSave"
            :disabled="isLoading"
            @click="saveAndUpdateApplicator"
          >
            {{ dadosAplicador.id ? "Atualizar" : "Salvar" }}
            <b-spinner v-if="isLoading" small label="Salvando" />
            <b-icon-check2-circle v-else class="ml-1" />
          </b-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import api from "../../services/axios";
import serviceApplicators from "../../services/serviceApplicators";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import { handleCpfOrCnpj } from "../../utils/validateCpfCnpj";
import { ufs } from "../../common/index";

const emptyApplicator = () => ({
  id: "",
  nomeAplicador: "",
  cpfCnpj: "",
  numeroRegistro: "",
  endereco: "",
  numero: "",
  bairro: "",
  cidade: "",
  cep: "",
  uf: "",
  email: "",
  telefone: "",
  celular: "",
  observacao: "",
  status: "Ativo",
});

export default {
  props: {
    idApplicatorFromSearch: { type: String, default: "" },
  },
  data() {
    return {
      dadosAplicador: emptyApplicator(),
      status: [
        { value: "Ativo", text: "Ativo" },
        { value: "Inativo", text: "Inativo" },
      ],
      ufs,
      isLoading: false,
      spinGeneral: false,
    };
  },
  computed: {
    ...mapState({
      dataSearchApplicator: (state) => state.dataSearchApplicator,
    }),
    maskCpfCnpj() {
      return (value) => {
        const mask =
          (value || "").replace(/\D/g, "").length > 11
            ? "##.###.###/####-##"
            : "###.###.###-##";
        return mask
          .split("")
          .map((character) => (character === "#" ? /\d/ : character));
      };
    },
    maskCep() {
      return "#####-###";
    },
    maskTelefone() {
      return "(##) ####-####";
    },
    maskCelular() {
      return "(##) #####-####";
    },
  },
  async mounted() {
    if (this.idApplicatorFromSearch) {
      try {
        const data = await serviceApplicators.findById(this.idApplicatorFromSearch);
        this.assignApplicator(data);
      } catch (error) {
        toastAlertErros.validateMessage(error, this.$toast);
      }
    } else if (this.dataSearchApplicator.id) {
      this.assignApplicator(this.dataSearchApplicator);
    }
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "SET_DATA_SEARCH_FROM_APPLICATOR",
    ]),
    assignApplicator(applicator) {
      Object.keys(this.dadosAplicador).forEach((key) => {
        if (applicator[key] !== undefined) {
          this.dadosAplicador[key] = applicator[key];
        }
      });
    },
    clear() {
      this.dadosAplicador = emptyApplicator();
      this.SET_DATA_SEARCH_FROM_APPLICATOR({});
    },
    async saveAndUpdateApplicator() {
      try {
        this.isLoading = true;
        const result = handleCpfOrCnpj(
          this.dadosAplicador.cpfCnpj,
          this.$toast
        );
        if (result && !result.isValid) return result.alert();

        const isUpdate = !!this.dadosAplicador.id;
        let savedId = this.dadosAplicador.id;
        if (isUpdate) {
          await api.put(
            `/applicators/${this.dadosAplicador.id}`,
            this.dadosAplicador
          );
        } else {
          const { data } = await api.post("/applicators", this.dadosAplicador);
          savedId = data.id;
        }

        this.SET_IS_SEARCH_REGISTERS();
        this.clear();
        this.$emit("saved", savedId);
        this.$toast.open({
          message: isUpdate
            ? "Aplicador Atualizado com Sucesso"
            : "Aplicador salvo com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message =
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message;
        const typeError = HandleErrors(message);
        if (typeof message === "string" && message.includes("NOT_ALLOWED")) {
          this.$toast.open({ message: message.split(":")[1], type: "info" });
        } else if (typeError?.message) {
          this.$toast.open({ message: typeError.message, type: "info" });
        } else {
          toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
        }
      } finally {
        this.isLoading = false;
      }
    },
    async fetchCep() {
      try {
        this.spinGeneral = true;
        const cep = this.dadosAplicador.cep.replace(/\D/g, "");
        const { data } = await api.get(
          `https://brasilapi.com.br/api/cep/v1/${cep}`
        );
        this.dadosAplicador.endereco = data.street;
        this.dadosAplicador.bairro = data.neighborhood;
        this.dadosAplicador.cidade = data.city;
        this.dadosAplicador.uf = data.state;
        this.dadosAplicador.cep = data.cep;
      } catch (error) {
        this.$toast.open({
          message:
            "Ocorreu um erro ao buscar as informações, verifique o CEP e tente novamente",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
  },
};
</script>

<style scoped>
.formContent {
  font-size: 12px;
}
span {
  font-weight: bold;
}
.title {
  font-size: 16px;
  color: #5f5f5f;
  display: flex;
  justify-content: space-between;
  margin: 0 20px 20px 0;
  border-bottom: 1px solid #e6e6e6;
}
.title span {
  font-weight: 600;
}
.requiredFields,
.validRed {
  color: red;
}
.requiredFields {
  font-size: 11px;
}
.validRed {
  font-size: 13px;
}
.rowContainer {
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 5px;
}
.lastRow {
  margin-bottom: 30px;
}
.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px;
  justify-content: space-between;
  gap: 10px;
}
.input-group,
.selectPlus {
  width: 30%;
}
.input {
  width: 100%;
  font-size: 12px;
}
.borderInput {
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  padding: 0 5px;
  color: #5c5855;
}
.borderInput:focus {
  border-color: #505050;
}
.user-label {
  position: absolute;
  left: 10px;
  bottom: 7px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  color: #666360;
}
.input:focus ~ label,
.input:not(:placeholder-shown) ~ label,
.input[type="date"] ~ label {
  transform: translateY(-50%) scale(0.8);
  background: white;
  padding: 0 0.1em;
  font-weight: 600;
}
.selectPlus {
  position: relative;
  display: flex;
  align-items: center;
}
.fixedSelect2 {
  position: absolute;
  margin: 0;
  font-size: 8.9px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  color: #555;
  background: white;
}
.custom-select {
  font-size: 11px;
  width: 100%;
  height: 30px;
  background: none;
}
.bcsCep {
  display: flex;
  align-items: center;
  height: 30px;
  position: absolute;
  right: 0;
  z-index: 2;
  font-size: 11px;
  border: none;
  border-radius: 5px;
  background: #c3c3c3;
}
.otherInfo {
  justify-content: flex-start;
}
.observations {
  width: 70%;
}
.btnsContainer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
}
.btnsSave,
.btnsSaveNeutral {
  width: 165px;
  margin-top: 30px;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
}
.btnsSave {
  background: #006256;
  color: white;
}
.btnsSaveNeutral {
  background: #d7d7d7;
  color: black;
}
.card {
  border: none !important;
}
@media (max-width: 700px) {
  .rowContent {
    flex-direction: column;
    padding: 5px 0;
  }
  .input-group,
  .selectPlus,
  .observations {
    width: 100%;
  }
}
</style>
